export const environment = {
  production: false,
  version: '1.0.88',
  apiUrl: 'https://31piyfahk0.execute-api.us-east-1.amazonaws.com/dev',
  azureAD: {
    clientId: 'bc4cb5fd-584a-4a5e-b341-dc3fc6ee59bf',
    tenantId: '389e4131-83ac-4189-909d-a0a3def85738'
  }
};
